import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@constants';
import { Typography } from '@mui/material';

export const renderDateCell = ({ value }: GridRenderCellParams) =>
  value ? <Typography variant="body2">{dayjs(value).format(DATE_FORMAT)}</Typography> : null;
